import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApplicationHttpService } from "../../../core/services/application-http.service";
import { ApproveActionRequest, ReassignActionRequest, RejectActionRequest, ReturnActionRequest } from "../models/action-request.model";
import { UserTaskAction } from "../models/user-task-action.model";
import { BackOfficeUserTask } from "../../../shared/models/application.model";
import { ApplicationStatus } from "../constants/application-status.enum";

export class CurrentTaskResponse {
    applicationId?: string;
    currentUserTask?: BackOfficeUserTask;
    status?: ApplicationStatus;
}

export class CurrentStatusResponse {
    id?: string;
    currentStatus?: ApplicationStatus;
}

/** Workflow task actions and status/task lookups (case officer / registrar / signatory). */
@Injectable()
export class ApplicationWorkflowService {

    constructor(private http: ApplicationHttpService) {
    }

    getCurrentTask(backOfficeApplicationId: number): Observable<CurrentTaskResponse> {
        return this.http.get<CurrentTaskResponse>(`back-office-application/${backOfficeApplicationId}/current-task`, null);
    }

    getCurrentStatus(backOfficeApplicationId: number): Observable<CurrentStatusResponse> {
        return this.http.get<CurrentStatusResponse>(`back-office-application/current-status/${backOfficeApplicationId}`, null);
    }

    //ASSIGNED
    review(taskId: string, backOfficeApplicationId: number): Observable<UserTaskAction> {
        return this.http.post(`case-officer-review/review`, {taskId, backOfficeApplicationId});
    }

    assign(body: ReassignActionRequest): Observable<any> {
        return this.http.post(`case-officer-review/reassign`, {taskId: body.taskId, backOfficeApplicationId: body.backOfficeApplicationId,
            assignee: body.assignee, reason: body.reason
        });
    }

    //UNDER_ASSESSMENT
    approve(body: ApproveActionRequest): Observable<any> {
        return this.http.post(`case-officer-assessment/approve`, body);
    }

    return(body: ReturnActionRequest): Observable<any> {
        return this.http.post(`case-officer-assessment/return`, body);
    }

    reject(body: RejectActionRequest): Observable<UserTaskAction> {
        return this.http.post(`case-officer-assessment/reject`, body);
    }

    reAssign(body: ReassignActionRequest): Observable<any> {
        return this.http.post(`case-officer-assessment/reassign`, body);
    }

    //AWAITING_APPROVAL
    registrarAssessment(taskId: string, backOfficeApplicationId: number, isRegistrarApproved: boolean): Observable<UserTaskAction> {
        return this.http.post(`registrar-assessment/complete`, {taskId, backOfficeApplicationId, isRegistrarApproved});
    }

    returnToCaseOfficer(taskId: string, backOfficeApplicationId: number, isRegistrarApproved: boolean, reason?: string): Observable<any> {
        return this.http.post(`registrar-assessment/complete`, {taskId, backOfficeApplicationId, isRegistrarApproved, reason});
    }

    sign(taskId: string, backOfficeApplicationId: number): Observable<any> {
        return this.http.post(`signatory-application/complete`, {taskId, backOfficeApplicationId, isRegistrarApproved:true});
    }

    returnToCaseOfficerFromCompanyRegistrar(taskId: string, backOfficeApplicationId: number, reason?: string): Observable<any> {
        return this.http.post(`signatory-application/complete`, {taskId, backOfficeApplicationId, isRegistrarApproved: false, reason});
    }

    caseOfficerList(): Observable<any[]> {
        return this.http.get<any[]>(`available-employee/case-officer/all`);
    }

    getActualAppId(id: number): Observable<number> {
        return this.http.get<number>(`back-office-application/get-actual-id?id=${id}`);
    }
}
